// extracted by mini-css-extract-plugin
export default {"container":"Reviews_container__Vpx6J","header":"Reviews_header__Xnnww","title":"Reviews_title__bYm10","content":"Reviews_content__VBB-p","stats":"Reviews_stats__JR-sk"};